import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const Close = ({ className, ...rest }: IProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    className={className}
    {...rest}
  >
    <g transform="translate(-12 -11.936)" fill="none" fillRule="evenodd">
      <g stroke="currentColor" strokeWidth="2">
        <path d="M13 13l10 10M23 13L13 23" />
      </g>
    </g>
  </svg>
);
